import { render, staticRenderFns } from "./welcomeBox.vue?vue&type=template&id=164c61a0&scoped=true"
import script from "./welcomeBox.vue?vue&type=script&lang=js"
export * from "./welcomeBox.vue?vue&type=script&lang=js"
import style0 from "./welcomeBox.vue?vue&type=style&index=0&id=164c61a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164c61a0",
  null
  
)

export default component.exports